module.exports = __webpack_public_path__ + "img/pinjia02.58a18654.jpg";